import React, { useContext, useEffect, useState, Fragment } from "react";
// import './Integration.css';
import styled from "styled-components";
import { XbeContext } from "./../CardsPage";
import { withRouter } from "react-router-dom";
import { Login } from "./Login";
import { FormGroup, Textarea, Button, Icon, Select, Input } from 'xsolla-uikit';
import MaterialIcon from 'material-icons-react';


function CardEmail1(props) {
  const context = useContext(XbeContext);
  // onClick={()=>props['history'].push(`?filters=${context["filters"].toString()}`)}

  const {
    step = 0,

    language = "en",

    appearance = "l",
    utm,
    id = 2051,
    salesCardId = 8,
    imageUrl,
    badgeText,
    title,
    description,
    learnMoreUrl,
    integrationTimeText,
    callToAction = "Get started",
    proposalText,
    postponed,
    project_id,
    project_name,
  } = { ...props };

  useEffect(() => {
    if (context && context["salesCards"].length) {
      let cardData = context["salesCards"].filter(
        (one) => one["fields"]["salesCardId"] === props["salesCardId"]
      )[0];
      if (cardData) {
        const {
          language = "en",

          appearance = "l",
          utm,
          id = 2051,
          salesCardId = 8,
          imageUrl,
          badgeText,
          title,
          description,
          learnMoreUrl,
          integrationTimeText,
          callToAction = "Get started",
          proposalText,
          postponed,
          project_id,
          project_name,
        } = { ...cardData["fields"] };
      }
    }
  }, [context]);

  const { filters } = { ...context };

  const [pa, setPa] = useState(step);

  const [login, setLogin] = useState();

  const [pa2, setPa2] = useState(pa);

  useEffect(() => {
    if (pa !== pa2 && !pa2) {
      setTimeout(() => {
        setPa2(pa);
      }, 200);
    } else {
      setPa2(pa);
    }
  }, [pa]);

  return (
    <CssEmailBody>
      <div className="c_email_cols">

        {/* PREVIEW */}
        <div className="c_emails_preview">
          <div className="xsbm_mailbg">
            <div className="xsbm_mailbg_0" />
            <div className="xsbm_mailbg_1" />
            <div className="xsbm_mailbg_2" />
          </div>

          <div className="c_email_content">
            <div className="xbe_email_top"
            style={{
              padding: '1em 0 0.6em 0',
              borderBottom: '1px solid #cfcfcf',
              fontSize: 13,
              display: 'flex'
            }}>
              <div style={{opacity: 0.6, marginRight: '1em'}}>Subject</div>
              <div className="">
               URGENT! {badgeText} {title}
              </div>
            </div>

            <div className="xbe_email_top">
              <div>
                <img
                  src="https://assets.website-files.com/5e589514a37e6e4ce2eff96a/5f17b4398ee5d70983d7b2ee_preview.png"
                  alt
                  className="image-14"
                />
              </div>
            </div>
            <div className="xbe_email_cont">
              <div className="xbe_email_hello">
                <div>
                  <strong>Hello Steve Johnson,</strong>
                </div>
              </div>
              <div className="xbe_email_intro">
                <div>
                  summer is in high gear at Xsolla. We’ve been busy adding new
                  features and improvements to our product to help you keep
                  delivering for your players during these uncertain times.
                </div>
              </div>
              <div className="xbe_email_for">
                <div>
                  Suggested for your project <br />‍
                  <strong>Xsollus Game Premium</strong>
                </div>
                <a href="#" className="xbe_email_goto w-inline-block">
                  <div>Go to project</div>
                </a>
              </div>
              <div className="c_emails_card">
                <div className="xbe_card xbe_card--email">
                  <div className="xbe_card_pic0">
                    <div className="xbe_card_pic xbe_card_pic--email">
                      <div
                        className="xbe_card_pic_abs xbe_card_pic_abs--email"
                        style={{
                          width: "100%",
                          backgroundImage: `url(${imageUrl})`,
                        }}
                      />
                      <div className="xbe_card_pic_grad" />
                    </div>
                  </div>
                  <div className="xbe_card_flex">
                    <div className="xbe_card_content">
                      <div className="xbe_card_line xbe_card_line--email">
                        <div className="xbe_card_badge0">{badgeText}</div>
                      </div>
                      <div className="xbe_card_line xbe_card_line--email">
                        <div className="xbe_card_title">
                          <div className="xbe_card_title xbe_card_title--email">
                            {title}
                          </div>
                        </div>
                      </div>
                      <div className="xbe_card_line xbe_card_line--email">
                        <div className="xbe_card_desc xbe_card_desc--email">
                          {description}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xbe_card_cta_email">
                    <div className="xbe_card_cta xbe_card_cta--email">
                      {callToAction}
                    </div>
                    <a
                      href={learnMoreUrl}
                      target="_blank"
                      className="xbe_card_cta_email_learnmore w-inline-block"
                    >
                      <div>Learn more about solution&nbsp;&nbsp;</div>
                      <div className="materialicons materialicons--18">
                        <div>open_in_new</div>
                      </div>
                    </a>
                    <a
                      href={callToAction}
                      target="_blank"
                      className="xbe_card_cta_email_learnmore w-inline-block"
                    >
                      <div>Assign to colleague&nbsp;&nbsp;</div>
                      <div className="materialicons materialicons--18">
                        <div>email</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="xbe_email_cont xbe_email_cont--wide">
              <div className="xbe_card_cta_email">
                <div className="xbe_card_cta_email_info">
                  <div className="xbe_card_cta_email_info_1">
                    <div className="materialicons">
                      <div>av_timer</div>
                    </div>
                    <div className="xbe_card_cta_email_info_2">
                      Integration time: <br />
                      less than 1 hour
                    </div>
                  </div>
                  <div className="xbe_card_cta_email_l" />
                  <div className="xbe_card_cta_email_info_1">
                    <div className="materialicons materialicons--22">
                      <div>build</div>
                    </div>
                    <div className="xbe_card_cta_email_info_2">
                      Skill required:{" "}
                      <strong>
                        webhooks, <br />
                        API-calls
                      </strong>
                      <a href="#" className="link" />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="xbe_email_cont xbe_email_cont--rel">
              <div className="xbe_email_cont">
                <div className="xbe_email_also_title">
                  <div>See also</div>
                </div>
                <div>
                  <div>
                    <div className="c_emails_card c_emails_card--also">
                      <div className="xbe_card xbe_card--email">
                        <div className="xbe_card_flex">
                          <div className="xbe_card_content">
                            <div className="xbe_card_line xbe_card_line--email">
                              <div className="xbe_card_badge0">
                                <div>Open new territories</div>
                              </div>
                            </div>
                            <div className="xbe_card_line xbe_card_line--email">
                              <div className="xbe_card_title">
                                <div className="xbe_card_title xbe_card_title--email-2">
                                  Build direct relationships with players to
                                  grow your business
                                </div>
                              </div>
                            </div>
                            <div className="xbe_card_line xbe_card_line--email">
                              <div className="xbe_card_desc xbe_card_desc--email-2">
                                <div>
                                  Create a loyal community, communicate with
                                  your players, and keep control of your
                                  cross-platform gamers’ data with our
                                  comprehensive distribution tools to represent
                                  your game.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="xbe_card_cta_email xbe_card_cta_email--2">
                          <div className="xbe_card_cta xbe_card_cta--email-secondary">
                            <div>Get Started&nbsp;</div>
                            <div className="materialicons materialicons--18">
                              <div>arrow_forward</div>
                            </div>
                          </div>
                          <a
                            href="http://xsolla.com/solutions/"
                            target="_blank"
                            className="xbe_card_cta_email_learnmore w-inline-block"
                          >
                            <div>Learn more&nbsp; </div>
                            <div className="materialicons materialicons--18">
                              <div>open_in_new</div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="c_emails_card c_emails_card--also">
                      <div className="xbe_card xbe_card--email">
                        <div className="xbe_card_flex">
                          <div className="xbe_card_content">
                            <div className="xbe_card_line xbe_card_line--email">
                              <div className="xbe_card_badge0">
                                SELL DIRECTLY TO PLAYERS
                              </div>
                            </div>
                            <div className="xbe_card_line xbe_card_line--email">
                              <div className="xbe_card_title">
                                <div className="xbe_card_title xbe_card_title--email-2">
                                  Distribute games more easily with flexible simplicity
                                </div>
                              </div>
                            </div>
                            <div className="xbe_card_line xbe_card_line--email">
                              <div className="xbe_card_desc xbe_card_desc--email-2">
                                <div>
                                Deliver game keys for every platform where your title is available and give you more control over where and how you sell.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="xbe_card_cta_email xbe_card_cta_email--2">
                          <div className="xbe_card_cta xbe_card_cta--email-secondary">
                            <div>Get Started&nbsp;</div>
                            <div className="materialicons materialicons--18">
                              <div>arrow_forward</div>
                            </div>
                          </div>
                          <a
                            href="http://xsolla.com/solutions/"
                            target="_blank"
                            className="xbe_card_cta_email_learnmore w-inline-block"
                          >
                            <div>Learn more&nbsp; </div>
                            <div className="materialicons materialicons--18">
                              <div>open_in_new</div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="xbe_email_sign">
              <div className="xbe_email_james0">
                <div className="xbe_email_james_1" />
                <div className="xbe_email_james_2">
                  <div className="text-block-32">James Jameson</div>
                  <div className="text-block-33">VIP&nbsp;of Sales, Europe</div>
                  <div className="text-block-31">
                    <a target="_blank" href="#" className="link-2">
                      james@xsolla.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="xbe_email_footer">
              <div>
                <p>
                  <strong>ABOUT XSOLLA</strong>
                </p>
                <p>
                  Xsolla is the video game business engine with a set of tools
                  and services that help to operate and sell more games. Serving
                  only the video game industry, the Xsolla product suite caters
                  works seamlessly to solve the complexities of distribution,
                  marketing, and monetization so developers, publishers, and
                  platform partners can increase their audience, sales and
                  revenue.
                </p>
              </div>
              <div className="xbe_email_footer_soc">
                <div>
                  <a href="#" className="link-3">
                    Facebook
                  </a>
                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                  <a href="#" className="link-3">
                    Twitter
                  </a>
                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                  <a href="#" className="link-3">
                    Linkedin
                  </a>
                </div>
              </div>
              <div>
                <div>
                  © 2006 — 2020 Xsolla Inc. | 15260 Ventura Blvd, Sherman Oaks,
                  CA 91403<br/>If you no longer wish to receive these emails you may{" "}
                  <a
                    href="http://email.veromailer.com/c/eJydkctO6zAQhp_G3UREjnNxssiipbBESOgAu8g4AzWKL7InLbz9sUN7TpBYIXkx_jz-558ZKbQT6s2QeudBKqfA4DBaLVRE-_4ryqXVG_k_EyKchjC_vIPElBbZvbfjLDH740aBEGH2dBBIGA-ZgVMmMHsOdppEhgcVsjBrDX4z9qJsabfWPgqvBCq7lN9uVM8oo5QXDaN1R3le5O31Daf7akeLummbZkcqegSfjE7gF6uHvmBFxytWdZTV3Vg0ouRF2b1KzitZQSU3vp9yHZuNnz8WX8vHqT8gOlJuCbuNRziXvwEm9fQcyWxi10F69QLx5jwcFZxIeTujHoKdvQRS7h9jPmFNYhpGNevIlpGdobQG45gjFRdy6b_cPyyTIaxm9DzSJd4aY2cjQaePCVx9pQiPBnw46yD4VOwOTmECjLf1ZNf7Yu392Tvrst9ub6V9CQc1Jn3eUsa_rdV5m4oPRugk3z8_JLl1Bn665eVn8wjaTdHaP4G_caPong"
                    target="_blank"
                    className="link-3"
                  >
                    unsubscribe
                  </a>{" "}
                  at any time
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CODE */}
        <div className="c_emails_code">
          <div style={{position: 'sticky', top: 40}}>
          <FormGroup>
            <FormGroup label="Subject">
              {/* <Input
                name="basic"
                input={{
                  // value: `${badgeText} ${title}`,
                  value: ()=><Fragment><span style=''>Badge</span></Fragment>,
                  onChange: () => void 0,
                }}
              /> */}


<div className="xsui-select">
                <div className="xsui-dropdown">
                  <div style={{ display: "block" }}>
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        display: "block",
                      }}
                    >
                      <button
                        name="item_type"
                        value="Default"
                        placeholder="Select"
                        className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only"
                        type="button"
                        data-id="item_type"
                        data-value="Default"
                      >
                        URGENT!&nbsp;&nbsp;<AdminTag>Badge</AdminTag>:&nbsp;&nbsp;
                          <AdminTag>Title</AdminTag>
                      </button>

                    </div>
                    <div className />
                  </div>
                  <div />
                </div>
              </div>


            </FormGroup>
          </FormGroup>



          <FormGroup>
            <FormGroup label="Email Top Text">
              <Textarea
                name="basic"
                input={{
                  value:
                    "summer is in high gear at Xsolla. We’ve been busy adding new features and improvements to our product to help you keep delivering for your players during these uncertain times.",
                  onChange: () => void 0,
                }}
              />
            </FormGroup>
          </FormGroup>

          <FormGroup>
            <FormGroup label="For exact project">
            <SelectPa icon>
                        3340: Xsollus Game Premium
            </SelectPa>

              {/* <Select
                  name="basic"
                  input={{
                    value: 'james',
                    onChange: ()=>void(0)
                  }}
                  options={[{
                    label: 'James',
                    value: 'james',
                  },{
                    label: 'Sam Gaglani',
                    value: 'sam',
                  }]}
                /> */}
            </FormGroup>
          </FormGroup>



          <FormGroup>
            <FormGroup label="Sent From">
              <SelectPa>
                James Jameson
              </SelectPa>


              {/* <Select
                  name="basic"
                  input={{
                    value: 'james',
                    onChange: ()=>void(0)
                  }}
                  options={[{
                    label: 'James',
                    value: 'james',
                  },{
                    label: 'Sam Gaglani',
                    value: 'sam',
                  }]}
                /> */}
            </FormGroup>
          </FormGroup>


          <FormGroup>
            <FormGroup label="Relevant solutions (optional)">
              <SelectPa>
                <AdminTag>Build direct relationships...</AdminTag>
              </SelectPa>

              {/* <Select
                  name="basic"
                  input={{
                    value: 'james',
                    onChange: ()=>void(0)
                  }}
                  options={[{
                    label: 'James',
                    value: 'james',
                  },{
                    label: 'Sam Gaglani',
                    value: 'sam',
                  }]}
                /> */}
            </FormGroup>
          </FormGroup>


          <FormGroup label="Email Code">
            <Button appearance="secondary" size="sm">
              <MaterialIcon
                color="currentColor"
                size="15"
                icon="content_copy"
              />
              &nbsp;&nbsp;Copy GetVero code
            </Button>
          </FormGroup>



          <FormGroup indentation='lg' label="Links">
            <FormGroup indentation='sm'>
              <Button appearance="flatten" size="sm">
                <MaterialIcon
                  color="currentColor"
                  size="15"
                  icon="link"
                />
                &nbsp;&nbsp;JIRA ticket
              </Button>
            </FormGroup>

            <FormGroup indentation='sm'>
              <Button appearance="flatten" size="sm">
                <MaterialIcon
                  color="currentColor"
                  size="15"
                  icon="link"
                />
                &nbsp;&nbsp;CRM campaigns with this email
              </Button>
            </FormGroup>

          </FormGroup>


        </div>
        </div>
      </div>
    </CssEmailBody>
  );
}

export const CardEmail = withRouter(CardEmail1);

const CssEmailBody = styled.div`
  padding-top: 60px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eff5ff;
  min-height: 100vh;
  z-index: 1000000;
`;

export const IntMarkAsDone = () => {
  return (
    <div className="p_x_doc0">
      <div className="p_x_doc">
        <div className="p_x_doc_b">
          <div className="p_button p_button--appearance-white">
            <div>mark as done</div>
          </div>
          <div className="l_line">
            This step requires you to follow the documentation
          </div>
        </div>
      </div>
    </div>
  );
};



export const SelectPa = ({children, icon}) => {
  return(<div className="xsui-select">
  <div className="xsui-dropdown">
    <div style={{ display: "block" }}>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "block",
        }}
      >
        <button
          name="item_type"
          value="Default"
          placeholder="Select"
          className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only"
          type="button"
          data-id="item_type"
          data-value="Default"
        >
          {children}
        </button>
        <div className="xsui-input__icon">
          <MaterialIcon
            color="currentColor"
            size="16"
            icon={typeof icon === 'text' ? icon : 'unfold_more'}
          />
        </div>
      </div>
      <div className />
    </div>
    <div />
  </div>
</div>)
}

export const AdminTag = ({children, icon}) => {
  return(<Fragment><span style={{
    backgroundColor: '#f7faff',
    border: '1px solid #c5d0db',
    padding: '0.2em 0.8em',
    borderRadius: 5
    }}>{children}</span></Fragment>)
}